import React from 'react';

var NextArrow = function NextArrow(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return React.createElement("div", {
    className: className,
    onClick: onClick
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "37",
    height: "11",
    viewBox: "0 0 37 11"
  }, React.createElement("path", {
    fill: "#828282",
    d: "M27.31.32l.435.244 8 4.5.775.436-.775.436-8 4.5-.436.245-.49-.872.436-.245L33.59 6H.5V5h33.091l-6.336-3.564-.436-.245.49-.872z"
  })));
};

export default NextArrow;